import React, { FC } from 'react';
import { Container, Row, Col, Stack, Image, Nav, NavLink, Button } from 'react-bootstrap';
import logo from '../beerxchange-logo-512.png';

interface Props {}

const Footer: FC<Props> = (props) => {
  return (
    <Container fluid className="footer_container">
      <Row className="donate_banner" style={{ textAlign: 'center', marginBottom: '20px' }}>
        <div>
          <h4>Support BeerXchange</h4>
          <Button variant="light" href="/donate">
            Donate
          </Button>{' '}
          to keep BeerXchange growing and ad free.
        </div>
      </Row>
      <Row>
        <Col>
          <Stack>
            <img src={logo} className="footer_logo" alt="logo" />
            <h2>BeerXchange</h2>
            <p>Find, trade, collect craft beer</p>
          </Stack>
        </Col>
        <Col>
          <Nav className="flex-column fs-5">
            Other Links
            <NavLink href="/about" className="text-black">
              About
            </NavLink>
            <NavLink href="/directories" className="text-black">
              Beer Directory
            </NavLink>
            <NavLink href="http://beerxchange.zendesk.com" className="text-black">
              Support
            </NavLink>
            <NavLink
              href="https://www.redbubble.com/people/beerxchange/shop"
              className="text-black"
            >
              Shop
            </NavLink>
            <NavLink href="/donate" className="text-black">
              Donate
            </NavLink>
            <NavLink href="/tos" className="text-black">
              Terms
            </NavLink>
          </Nav>
        </Col>
        <Col>
          <h4>Contact us</h4>
          <p>contact@beerxchange.com</p>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;
